import { clientEnv } from "../env";
import { readStoredSession } from "./auth-client";

export type WritingStatus = "suggested" | "unchanged" | "declined" | "unavailable" | "busy";
export interface WritingReply { status: WritingStatus; text?: string }

export function subscribeWritingSession(listener: () => void) {
  window.addEventListener("omnisynia:session-change", listener);
  window.addEventListener("storage", listener);
  return () => {
    window.removeEventListener("omnisynia:session-change", listener);
    window.removeEventListener("storage", listener);
  };
}
export function writingSessionToken(): string {
  const session = readStoredSession();
  return session && Date.parse(session.expiresAt) > Date.now() ? session.sessionToken : "";
}

export async function requestWritingReview(text: string, language: string, kind: "prose" | "title", token: string, signal: AbortSignal): Promise<WritingReply> {
  if (!token || writingSessionToken() !== token) return { status: "unavailable" };
  const response = await fetch(`${clientEnv.apiBaseUrl}/ai/writing-review`, {
    method: "POST", redirect: "error",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify({ text, language, kind }),
    signal: AbortSignal.any([signal, AbortSignal.timeout(17_000)])
  });
  if (signal.aborted || writingSessionToken() !== token) throw new DOMException("Revisión cancelada", "AbortError");
  if (response.status === 429) return { status: "busy" };
  if (!response.ok) return { status: "unavailable" };
  const result: unknown = await response.json();
  if (!result || typeof result !== "object") return { status: "unavailable" };
  const data = result as WritingReply;
  if (!["suggested", "unchanged", "declined", "unavailable", "busy"].includes(data.status) ||
      (data.status === "suggested" && (typeof data.text !== "string" || data.text.length > 8100))) return { status: "unavailable" };
  return data;
}
